import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Workbox } from 'workbox-window';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    loadServiceWorker();
  })
  .catch(err => console.error(err));

function loadServiceWorker(): void {
  if ('serviceWorker' in navigator) {
    const wb = new Workbox('service-worker.js');
    wb.register()
      .then(() => console.log('Service worker was succesfully registered.'))
      .catch((err => console.error('Error while registering service-worker: ', err)));
  }
  else {
    console.warn('No serviceWorker in navigator. Make sure you\'re using a secure connection (https).');
  }
}
